/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Testimonials_BadgeInputs */

const en_landing_testimonials_badge = /** @type {(inputs: Landing_Testimonials_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How it works under the hood`)
};

const de_landing_testimonials_badge = /** @type {(inputs: Landing_Testimonials_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So funktioniert es unter der Haube`)
};

const fr_landing_testimonials_badge = /** @type {(inputs: Landing_Testimonials_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment ça fonctionne sous le capot`)
};

const es_landing_testimonials_badge = /** @type {(inputs: Landing_Testimonials_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo funciona por dentro`)
};

const it_landing_testimonials_badge = /** @type {(inputs: Landing_Testimonials_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come funziona sotto il cofano`)
};

const nl_landing_testimonials_badge = /** @type {(inputs: Landing_Testimonials_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe het werkt onder de motorkap`)
};

const pl_landing_testimonials_badge = /** @type {(inputs: Landing_Testimonials_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak to działa pod maską`)
};

const fi_landing_testimonials_badge = /** @type {(inputs: Landing_Testimonials_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näin se toimii konepellin alla`)
};

const da_landing_testimonials_badge = /** @type {(inputs: Landing_Testimonials_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sådan fungerer det under motorhjelmen`)
};

const sv_landing_testimonials_badge = /** @type {(inputs: Landing_Testimonials_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hur det fungerar under huven`)
};

/**
* | output |
* | --- |
* | "How it works under the hood" |
*
* @param {Landing_Testimonials_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_testimonials_badge = /** @type {((inputs?: Landing_Testimonials_BadgeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Testimonials_BadgeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_testimonials_badge(inputs)
	if (locale === "fr") return fr_landing_testimonials_badge(inputs)
	if (locale === "es") return es_landing_testimonials_badge(inputs)
	if (locale === "it") return it_landing_testimonials_badge(inputs)
	if (locale === "nl") return nl_landing_testimonials_badge(inputs)
	if (locale === "pl") return pl_landing_testimonials_badge(inputs)
	if (locale === "fi") return fi_landing_testimonials_badge(inputs)
	if (locale === "da") return da_landing_testimonials_badge(inputs)
	if (locale === "sv") return sv_landing_testimonials_badge(inputs)
	return en_landing_testimonials_badge(inputs)
});